﻿import moment from 'moment';
import momentTz from 'moment-timezone';
import { createToast } from 'mosha-vue-toastify';

const helper = {
  getUserId() {
    let USER_DATA = localStorage.getItem('USER_DATA');
    USER_DATA = JSON.parse(USER_DATA);
    if (!USER_DATA) return '';
    return USER_DATA._id;
  },
  getImagePath(url) {
    let token = localStorage.getItem('id_token');
    if (token) {
      return `${url}&authorization=Bearer ${token}`;
    }
    return `${url}`;
  },
  getValidationRules(item) {
    let lang = window.localStorage.getItem('lang');
    lang = lang ? lang : 'ar';
    let rules = {};
    if (item) {
      if (item.type == 'Email') {
        rules['email'] = true;
      }

      if (item.hasOwnProperty('is_required') && !item.is_required) {
        rules['required'] = false;
      } else {
        rules['required'] = true;
      }

      if (item.min_length) {
        rules['min'] = item.min_length;
      }
      if (item.max_length) {
        rules['max'] = item.max_length;
      }
      if (lang == 'en') {
        if (item.regex_validation) {
          rules['regex'] = item.regex_validation ? item.regex_validation : item.regex_validation_ar;
        }
      } else {
        if (item.regex_validation_ar) {
          rules['regex'] = item.regex_validation_ar ? item.regex_validation_ar : item.regex_validation;
        }
      }
      if (item.type == 'Check') {
        rules['min'] = 1;
        delete rules['max'];
      }
      if (item.type == 'DropDownList') {
        delete rules['min'];
        delete rules['max'];
      }

    }

    return rules;
  },
  getTranslated(object) {
    let lang = window.localStorage.getItem('lang');
    lang = lang ? lang : 'ar';
    return object[lang];
  },
  getStartHTML(value = 0) {
    let html = '';
    for (let i = 0; i < 5; i++) {
      if (Math.floor(value) - i >= 1) {
        html += '<i class="fas fa-star text-warning"> </i>';
      } else if (value - i > 0) {

        html += '<i class="fas fa-star-half-alt text-warning"> </i>';
      } else {

        html += '<i class="far fa-star text-warning"> </i>';
      }
    }
    return html;
  },
  errorNotify(title, description) {
    createToast({
      title: title,
      description: description,
    }, {
      type: 'danger', // 'info', 'danger', 'warning', 'success', 'default'
      timeout: 5000,
      showIcon: true,
      position: 'bottom-left', // 'top-left', 'top-right', 'bottom-left', 'bottom-right', 'top-center', 'bottom-center'
      transition: 'bounce',
      hideProgressBar: false,
      swipeClose: true,
      // toastBackgroundColor: '#fafafa',
      // onClose: null
    });
  },
  successNotify(title, description) {
    createToast({
      title: title,
      description: description,
    }, {
      type: 'success', // 'info', 'danger', 'warning', 'success', 'default'
      timeout: 5000,
      showIcon: true,
      position: 'bottom-left', // 'top-left', 'top-right', 'bottom-left', 'bottom-right', 'top-center', 'bottom-center'
      transition: 'bounce',
      hideProgressBar: false,
      swipeClose: true,
      // toastBackgroundColor: '#fafafa',
      // onClose: null
    });
  },
  getOrderStatus() {
    return [
      { key: 'accepted', bgColor: 'bg-primary', badgeColor: 'badge-primary' },
      { key: 'pending', bgColor: 'bg-info', badgeColor: 'badge-info' },
      { key: 'cancelled', bgColor: 'bg-danger', badgeColor: 'badge-danger' },
      { key: 'rejected', bgColor: 'bg-danger', badgeColor: 'badge-danger' },
      { key: 'completed', bgColor: 'bg-success', badgeColor: 'badge-success' },
      { key: 'delivered', bgColor: 'bg-success', badgeColor: 'badge-success' },
      { key: 'paid', bgColor: 'bg-success', badgeColor: 'badge-dark' },
      { key: 'timedout', bgColor: 'bg-warning', badgeColor: 'badge-warning' },
    ];
  },
  getNotificationSMSStatus() {
    return [
      { key: 'accepted', bgColor: 'bg-primary', badgeColor: 'badge-primary' },
      { key: 'pending', bgColor: 'bg-info', badgeColor: 'badge-info' },
      { key: 'cancelled', bgColor: 'bg-danger', badgeColor: 'badge-danger' },
      { key: 'rejected', bgColor: 'bg-danger', badgeColor: 'badge-danger' },
      // { key: "completed", bgColor: "bg-success", badgeColor: "badge-success" },
      // { key: "delivered", bgColor: "bg-success", badgeColor: "badge-success" },
      // { key: "paid", bgColor: "bg-success", badgeColor: "badge-dark" },
      { key: 'executed', bgColor: 'bg-warning', badgeColor: 'badge-warning' },
    ];
  },
  findStatusByKey(key) {
    let statuses = this.getOrderStatus();
    let data = statuses.filter((item) => {
      return key == item.key;
    });
    if (data.length) return data[0];
    return null;
  },
  handleResponse(response, translate, router, store, passObject = {}) {
    let current_lang = localStorage.getItem('lang') ? (localStorage.getItem('lang')) : 'ar';
    if (response.response) {
      // The request was made and the server responded with a status code

      // validation error over api
      // || (response.response.status == 400)
      if ((response.response.status == 422)) {
        let validationApi = response.response.data.feedback;
        let validationObj = {};
        for (let [key, value] of Object.entries(validationApi.fields)) {
          validationObj[key] = [value[0][current_lang]];
        }
        if (passObject.setErrors) {
          passObject.setErrors(validationObj);
        }

        this.errorNotify(translate('error'), translate('server_error_422'));
        return;
      }
      // if ((response.response.status == 400)) {
      //     let validationApi = response.response.data.feedback;
      //     let validationObj = {};
      //     for (let [key, value] of Object.entries(validationApi.fields)) {
      //         validationObj[key] = [value[current_lang]];
      //     }
      //     if (passObject.setErrors) {
      //         passObject.setErrors(validationObj);
      //     }
      //
      //     this.errorNotify(translate("error"), translate("server_error_400"));
      //     return;
      // }

      if ((response.response.status == 400)) {
        let validationApi = response.response.data.feedback;
        let message = validationApi.message[current_lang];
        this.errorNotify(translate('error'), message);
        return;
      }
      // un authenticated
      if (response.response.status == 401) {
        window.localStorage.removeItem('LOGIN_PAYLOAD');
        window.localStorage.removeItem('USER_DATA');
        window.localStorage.removeItem('id_token');
        router.push({ name: 'login_page' });
        // return;
      }

      // permission denied
      if (response.response.status == 403) {
        //router.push({name: 'pageError403'})
        return;
      }

      // default 500 message
      let message = translate('server_error');
      if (response.response.status == 401) message = translate('server_error_401');
      if (response.response.status == 400) message = response.response.data.error ? response.response.data.error : response.response.data.feedback.message[current_lang];//translate("server_error_400");
      if (response.response.status == 403) message = translate('server_error_403');
      if (response.response.status == 404) message = translate('server_error_404');

      this.errorNotify(translate('error'), message);
    } else if (response.request) {
      // The request was made but no response was received

      this.errorNotify(translate('error'), translate('server_error'));

    } else {
      // Something happened in setting up the request that triggered an Error

      // this.errorNotify(translate('error'), response.message);
      // console.log('Error', response.message);
    }
  },
  formatDate: (value, format = 'YYYY-MM-DD HH:mm a') => {
    if (value) {
      return moment(new Date(value)).format(format);
    }
  },
  isSameOrBefore: (startTime, endTime) => {
    return moment(startTime, 'HH:mm').isBefore(moment(endTime, 'HH:mm'));
  },
  isSameOrAfter: (startTime, endTime) => {
    return moment(startTime, 'HH:mm').isAfter(moment(endTime, 'HH:mm'));
  },
  parseNumber(amount) {
    if (!amount) amount = 0;
    return parseFloat(amount).toFixed(2);
  },
  prepareRequestData(payload) {

    // delete payload.method;
    // delete payload.path;
    // delete payload.namespace;
    //
    return payload;
  },
  validationGroupingData: (xs, key) => {
    return xs.reduce(function(rv, x) {
      (rv[x[key]] = rv[x[key]] || []).push(x);
      return rv;
    }, {});
  },
  diffTwoDates: (from_date, to_date) => {
    return moment(new Date(from_date)).diff(to_date, 'days');
  },
  splitHostname() {
    let result = {};
    let url = window.location.href;

    url = url.replace(new RegExp(/^\s+/), '');
    url = url.replace(new RegExp(/\s+$/), '');
    url = url.replace(new RegExp(/\\/g), '/');
    url = url.replace(new RegExp(/^http\:\/\/|^https\:\/\/|^ftp\:\/\//i), '');
    url = url.replace(new RegExp(/^www\./i), '');
    url = url.replace(new RegExp(/\/(.*)/), '');
    if (url.match(new RegExp(/\.[a-z]{2,3}\.[a-z]{2}$/i))) {
      url = url.replace(new RegExp(/\.[a-z]{2,3}\.[a-z]{2}$/i), '');
    } else if (url.match(new RegExp(/\.[a-z]{2,4}$/i))) {
      url = url.replace(new RegExp(/\.[a-z]{2,4}$/i), '');
    }
    result.hasSubdomain = (url.match(new RegExp(/\./g))) ? true : false;
    result.data = url.split('.');
    return result;
  },
  saveAccountCredential(data) {
    let key = 'accountApi';
    let accountApi = JSON.parse(localStorage.getItem(key));
    if (accountApi) {
      // append data
      _.forEach(data, (v, k) => {
        accountApi[k] = v;
      });
      localStorage.setItem(key, JSON.stringify(accountApi));
    } else {
      localStorage.setItem(key, JSON.stringify(data));
    }
  },
  validateFormErrors(vm) {
    return vm.errors.any();
  },
  checkNestedObjectProp(obj /*, level1, level2, ... levelN*/) {
    let args = Array.prototype.slice.call(arguments, 1);

    for (let i = 0; i < args.length; i++) {
      if (!obj || !obj.hasOwnProperty(args[i])) {
        return false;
      }
      obj = obj[args[i]];
    }
    return true;
  },
  removeFromArray: (array, remove) => {
    const index = array.indexOf(remove);
    if (index > -1) {
      array.splice(index, 1);
    }
    return array;
  },
  generateRandomValues() {
    return Math.random().toString(16).slice(-8);
  },
  diffForhuman(date) {
    if (!date) return '';
    let delta = Math.round((new Date() - new Date(date)) / 1000);

    let minute = 60;
    let hour = minute * 60;
    let day = hour * 24;
    let week = day * 7;

    let fuzzy = '';

    if (delta < 30) {
      fuzzy = 'just then.';
    } else if (delta < minute) {
      fuzzy = delta + ' seconds ago.';
    } else if (delta < 2 * minute) {
      fuzzy = 'a minute ago.';
    } else if (delta < hour) {
      fuzzy = Math.floor(delta / minute) + ' minutes ago.';
    } else if (Math.floor(delta / hour) == 1) {
      fuzzy = '1 hour ago.';
    } else if (delta < day) {
      fuzzy = Math.floor(delta / hour) + ' hours ago.';
    } else if (delta < day * 2) {
      fuzzy = 'yesterday';
    } else if (delta < week) {
      fuzzy = Math.floor(delta / day) + 1 + ' days ago.';
    } else {
      fuzzy = '';
    }

    return fuzzy;
  },
  makeid(length) {
    var result = '';
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  },
  deleteMulti(ids, collection) {
    return _.dropWhile(collection, function(n) {
      return _.includes(ids, n.id);
    });
  },
  JSON_to_URLEncoded(element, key, list) {
    var list = list || [];
    if (typeof (element) == 'object') {
      for (var idx in element)
        JSON_to_URLEncoded(element[idx], key ? key + '[' + idx + ']' : idx, list);
    } else {
      list.push(key + '=' + encodeURIComponent(element));
    }
    return list.join('&');
  },
  getCollectionMethods() {
    return ['kafd', 'drive_thru', 'walk_thru', 'delivery', 'marsool', 'granada_business'];
  },
  googleMapStyleDefaultCenter() {
    return { lat: 24.797760, lng: 46.702699 };
  },
  googleMapStyle() {
    return [
      {
        'stylers': [
          {
            'hue': '#2196f3',
          },
        ],
      },
      {
        'featureType': 'road',
        'elementType': 'labels',
        'stylers': [
          {
            'visibility': 'off',
          },
        ],
      },
      {
        'featureType': 'road',
        'elementType': 'geometry',
        'stylers': [
          {
            'lightness': 100,
          },
          {
            'visibility': 'simplified',
          },
        ],
      },
    ];
  },
  googleMapKEY() {
    return 'AIzaSyCoxBvMubDUsEJ-boPiGhAZ8y15fafygOE';
  },
  Chatra() {
    (function(d, w, c) {
      w.ChatraID = 'xmsZSbcQaFELdNRZu';
      var s = d.createElement('script');
      w[c] = w[c] || function() {
        (w[c].q = w[c].q || []).push(arguments);
      };
      s.async = true;
      s.src = 'https://call.chatra.io/chatra.js';
      console.log(s);
      if (d.head) d.head.appendChild(s);
    })(document, window, 'Chatra');
  },
  OptimizeImage(file){
    const MAX_WIDTH = 320;
    const MAX_HEIGHT = 180;
    const MIME_TYPE = "image/jpeg";
    const QUALITY = 0.7;
    const blobURL = URL.createObjectURL(file);
    const img = new Image();
    const vm = this;
    img.src = blobURL;
    return new Promise((resolve, reject) => {
      img.onerror = function() {
        URL.revokeObjectURL(this.src);
        // Handle the failure properly
        reject("Cannot load image")
      };
      img.onload = function() {
        URL.revokeObjectURL(this.src);
        const [newWidth, newHeight] = vm.calculateSize(img, MAX_WIDTH, MAX_HEIGHT);
        const canvas = document.createElement("canvas");
        canvas.width = newWidth;
        canvas.height = newHeight;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, newWidth, newHeight);
        canvas.toBlob(
          (blob) => {
            resolve({
              originalFile:file,
              compressFile:blob
            })
          },
          MIME_TYPE,
          QUALITY
        );
        // document.getElementById("root").append(canvas);
      };
    });
  },
  calculateSize(img, maxWidth, maxHeight) {
  let width = img.width;
  let height = img.height;

  // calculate the width and height, constraining the proportions
  // if (width > height) {
  //   if (width > maxWidth) {
  //     height = Math.round((height * maxWidth) / width);
  //     width = maxWidth;
  //   }
  // } else {
  //   if (height > maxHeight) {
  //     width = Math.round((width * maxHeight) / height);
  //     height = maxHeight;
  //   }
  // }
  return [width, height];
}
};
export default helper;
